import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { LoginOAuthParams } from '../../../models';
import {
  InitiateSsoOperationTypes,
  InitiateSsoSession
} from '../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class InitiateSsoSessionService {
  initiateSsoSessionHeader: HttpHeadersPayload = {
    'Content-Type':
      'application/vnd.pingidentity.initiateOAuthAuthorization+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  initiateSsoSession = (
    loginOAuthParams: LoginOAuthParams,
    operationType: InitiateSsoOperationTypes
  ): Observable<InitiateSsoSession> => {
    let getInitiateSsoSessionUrl = '';

    getInitiateSsoSessionUrl = this.getInitiateSsoSessionUrl(
      loginOAuthParams,
      operationType
    );

    const initiateSsoSessionUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getInitiateSsoSessionUrl
      }
    ];

    return new ApiBuilder<undefined, InitiateSsoSession>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(initiateSsoSessionUrl)
      .method(HttpRequestMethods['GET'])
      .timeOut(loginOAuthParams.oauthConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.initiateSsoSessionHeader)
      .errorHandler(this._errorHandler)
      .library('INITIATE_SSO_SERVICE')
      .withCredentials(true)
      .create();
  };

  private getInitiateSsoSessionUrl(
    loginOAuthParams: LoginOAuthParams,
    operationType: InitiateSsoOperationTypes
  ): string {
    const initiateSsoSessionUrl = {
      NEW_USER_WITH_VALIDATION: this.utils.getPingServiceUrl(
        loginOAuthParams?.oauthConfig,
        '',
        loginOAuthParams?.pkceCode?.codeChallenge
      ).newUserMfaLoginOAuthUrlEmailValidation,
      NEW_USER_WITHOUT_VALIDATION: this.utils.getPingServiceUrl(
        loginOAuthParams?.oauthConfig,
        '',
        loginOAuthParams?.pkceCode?.codeChallenge
      ).newUserMfaLoginOAuthUrlWithoutEmailValidation,
      SELF_SERVICE_RESET_PASSWORD: this.utils.getPingServiceUrl(
        loginOAuthParams?.oauthConfig,
        '',
        loginOAuthParams?.pkceCode?.codeChallenge
      ).selfServiceResetLoginOAuthUrl,
      CHANGE_PASSWORD: this.utils.getPingServiceUrl(
        loginOAuthParams?.oauthConfig,
        '',
        loginOAuthParams?.pkceCode?.codeChallenge
      ).loginOAuthUrlPersistant,
      DEFAULT: this.utils.getPingServiceUrl(
        loginOAuthParams?.oauthConfig,
        '',
        loginOAuthParams?.pkceCode?.codeChallenge
      ).mfaLoginOAuthUrl
    };
    return initiateSsoSessionUrl[operationType];
  }
}
